 
class SearchAccountingEntry {

  constructor() {
    this.id = undefined;
    this.timeStamp = undefined;
    this.amount = undefined;
    this.title = undefined;
    this.isProfit = undefined;
    this.description = undefined;
    this.category = undefined;
    this.employeeId = undefined;
    this.patientId = undefined;
    this.facilityId = undefined;
    this.entryType = undefined;
    this.accountingSessionId = undefined;
    this.therapistId = undefined;
    this.accountingTherapistHourId = undefined;
    
    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined
    }

  }
}
export default new SearchAccountingEntry();
 